module.exports = __webpack_public_path__ + "static/media/play-btn.dacdb309.png";